<template>
  <div>
    <vs-prompt
      @close="close"
      @accept="acceptAlert"
      buttonAccept="false"
      buttonCancel="false"
      :active="activePrompt"
      title="Add Tags"
    >
      <h3 class="text-center mb-4">Add Tags</h3>
      <div class="con-exemple-prompt">
        <span class="mb-1">Tag Name</span>
        <vs-input
          placeholder="Batch 14' S.Y.19-20"
          vs-placeholder="Batch 14' S.Y.19-20"
          v-model="form.tag_name"
          class="w-full mb-3"
        />
        <div class="flex mt-3">
          <vs-button class="ml-auto">Save</vs-button>
        </div>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
export default {
  props: {
    activePrompt: Boolean
  },
  data () {
    return {
      modal: null,
      showDescription: false,
      form: {
        tag_name: '',
      }
    }
  },
  methods: {
    changeModal (name) {
      this.modal = name
    },
    handleShow () {
      this.showDescription = true
    },
    acceptAlert () {
      this.$vs.notify({
        color: 'success',
        title: 'Accept Selected',
        text: 'Lorem ipsum dolor sit amet, consectetur'
      })
    },
    close () {
      this.$vs.notify({
        color: 'danger',
        title: 'Closed',
        text: 'You close a dialog!'
      })
      this.$emit('cancel')
      this.showDescription = false
      this.form = {
        title: '',
        description: ''
      }
    },
    closeModal () {
      this.activePrompt = false
    }
  }
}
</script>

<style>
.vs-dialog {
  max-width: 570px !important;
}

.con-vs-dialog .vs-dialog header {
  background: none;
  height: 48px;
}

.vs-dialog-cancel {
  color: #6e6b7b;
  transform: translate(0, 0) !important;
  box-shadow: none !important;
}

.vs-dialog-cancel:hover {
  box-shadow: 0 5px 20px 0 rgb(0 0 0 / 10%) !important;
}

.menu-button {
  width: 100%;
  justify-content: left;
  padding: 8px 16px 8px 16px !important;
  font-size: 16px !important;
  margin-top: 16px;
  margin-bottom: 30px;
}
</style>
